<template>
	<v-container class="awards none-fluid link">
		<banner>Awards</banner>
		<anchor-bar :data="awards" />
		<br />
		<v-expansion-panels multiple v-model="panels" class="mx-auto awards-content">
			<v-expansion-panel
				v-for="section in awards"
				:key="section.title"
				expand
				:id="section.title.replace(/\s/gi, '-')"
			>
				<v-expansion-panel-header class="expansion-header">{{ section.title }}</v-expansion-panel-header>
				<v-expansion-panel-content class="expansion-content">
					<div v-for="child in section.children" :key="child.subtitle" class="expansion-subsection">
						<h4 v-if="child.subtitle" class="expansion-subtitle">{{ child.subtitle }}</h4>
						<ul v-if="child.hasList">
							<li v-for="content in child.content" :key="content" class="expansion-li" v-html="content"></li>
						</ul>
						<div v-else>
							<div v-for="content in child.content" :key="content" v-html="content"></div>
						</div>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import AnchorBar from "../global/AnchorBar";
import { getAllAwards } from "../../service/about/awards";

export default {
	components: {
		Banner,
		AnchorBar
	},
	data() {
		return {
			awards: [],
			panels: []
		};
	},
	mounted() {
		getAllAwards()
			.then(awards => {
				this.awards = awards;
				for (let i = 0; i < awards.length; ++i) {
					this.panels.push(i);
				}
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>
